import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetParamsAndResolver } from '@cbridge-utils/redux-observable';
import { catchApiError } from '@cbridge-packages/api-base';
import { IMarkoutApiDependencySegment } from '@cbridge-packages/api-markout';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { MarkoutAction } from '../markout.action';

type IDependencies = IMarkoutApiDependencySegment;

export const retryReportEpic: IEpic<{}, IDependencies> = (action$, _, { moApi }) =>
  action$.pipe(
    isTypeOfAndGetParamsAndResolver(MarkoutAction.retryReport.started),
    switchMap(({ params, resolve, reject }) => (
      moApi.retryReport(params.reportId).pipe(
        mergeMap(() => {
          resolve?.();
          return [
            MarkoutAction.retryReport.done({ params, result: undefined }),
            MarkoutAction.loadReports.started({}),
          ];
        }),
        catchApiError((error) => {
          const isHandled = reject?.(error.errorCode, error.description, error.params);
          return [
            MarkoutAction.retryReport.failed({ params, error }),
            ...(isHandled ? [] : [createApiErrorNotification(error)]),
          ];
        }),
      )
    )),
  );
